<form class="form-horizontal" autocomplete="off" #createForm="ngForm" (ngSubmit)="selecionarDependente()">
    <abp-modal-header title="Selecionar Dependente" (onCloseClick)="bsModalRef.hide()"></abp-modal-header>
    <div class="modal-body">
        <label class="col-12 col-form-label row" for="nome">
            Dependente:
        </label>
        <div class="form-group row mb-3">
            <div class="col-12">
                <select class="custom-select kt-input select-with-placeholder" name="selecaoDependente"
                    id="selecaoDependente" [(ngModel)]="dependenteSelecionado">
                    <option disabled [ngValue]="undefined">
                        Selecione um dependente...
                    </option>
                    <option *ngFor="let dependente of dependentes" [value]="dependente.id">
                        {{ dependente.nome }}
                    </option>
                </select>
            </div>
        </div>
        <br>


        <abp-modal-footer class="rodape" (onCancelClick)="bsModalRef.hide()" [saveLabel]="'Selecionar'">
        </abp-modal-footer>
    </div>
</form>